import {
  CassetteIcon,
  CategoryIcon,
  CompactDiscIcon,
  MicrophoneIcon,
  MusicIcon,
  MusicLibraryIcon,
  ReleaseFormatIcon,
  ReleaseIcon,
  VideoIcon,
} from "@/components/appIcons";
import type { AppIcon } from "@/components/appIcons";
import { ALBUM_TYPES } from "@garimpa/lib/albumTypes";
import { FORMAT_CATEGORIES } from "@garimpa/lib/formatGroups";

export const ALBUM_TYPE_ICONS: Record<(typeof ALBUM_TYPES)[number], AppIcon> = {
  album: ReleaseIcon,
  compilation: MusicLibraryIcon,
  single_ep: MusicIcon,
  live: MicrophoneIcon,
  video: VideoIcon,
  other: CategoryIcon,
};

export const FORMAT_CATEGORY_ICONS: Record<(typeof FORMAT_CATEGORIES)[number], AppIcon> = {
  vinyl: ReleaseFormatIcon,
  cd: CompactDiscIcon,
  cassette: CassetteIcon,
  video: VideoIcon,
};

export const FORMAT_LABEL_KEYS = {
  vinyl: "formatVinyl",
  cd: "formatCD",
  cassette: "formatCassette",
  video: "formatVideo",
} as const;
